import { createFeatureSelector, createSelector } from '@ngrx/store';
import type { TaskReferenceState } from './task-reference.models';

export const selectTaskReferenceState = createFeatureSelector<TaskReferenceState>('taskReference');

export const selectTaskReferenceItems = createSelector(
  selectTaskReferenceState,
  (state) => state.items,
);

export const selectTaskReferenceLoading = createSelector(
  selectTaskReferenceState,
  (state) => state.loading,
);

export const selectTaskReferenceError = createSelector(
  selectTaskReferenceState,
  (state) => state.error,
);
